import { DialogClasses, Dialog, useTheme, useMediaQuery } from '@mui/material';
import { getMapDialogCommonStyles } from 'components/Map/utils';
import { ReactNode, useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { MAP_ENTITY_DRAWER_MOBILE_DRAWER_ID } from 'components/Map/MapEntityDrawer';
import { useWaitForElement } from 'hooks/useWaitForElement';
import { useDrawerHeightListener } from 'components/Map/MapEntityDrawer/useDrawerHeightListener';
import { MAP_DOM_ELEMENT_ID } from '../../../../constants';

type ProgressionModelDialogProps = {
  children: ReactNode;
};

const useStyles = makeStyles<{ drawerHeight: number }>()(
  (theme, { drawerHeight }) => ({
    ...getMapDialogCommonStyles(theme, {
      isDrawerEntitySelected: true,
      isSearchDrawerOpen: false,
      interactive: false,
      minWidth: 362,
      minSnapPct: 0.47,
      yOffset: drawerHeight,
    }),
  }),
);

export const ProgressionModelDialog = (
  props: ProgressionModelDialogProps,
): JSX.Element => {
  const { children } = props;
  const theme = useTheme();
  const isLargeMediaQuery = useMediaQuery(theme.breakpoints.up('tablet'));
  const drawerElement = useWaitForElement(
    isLargeMediaQuery ? null : `#${MAP_ENTITY_DRAWER_MOBILE_DRAWER_ID}`,
  );
  const drawerHeight = useDrawerHeightListener(drawerElement);
  const { classes } = useStyles({ drawerHeight });

  const dialogClasses = useMemo(
    (): Partial<DialogClasses> => ({
      root: classes.root,
      container: classes.container,
      paper: classes.paper,
    }),
    [classes.root, classes.container, classes.paper],
  );

  return (
    <Dialog
      open
      classes={dialogClasses}
      hideBackdrop
      container={(): HTMLElement | null =>
        document.getElementById(MAP_DOM_ELEMENT_ID)
      }
    >
      {children}
    </Dialog>
  );
};
